export const PopoverStyles = {
  baseStyle: {
    content: {
      border: "none",
      fontSize: "base",
    },
  },
  variants: {
    solid_white: {
      content: {
        backgroundColor: "white",
        boxShadow: "primary",
      },
    },
  },

  sizes: {
    base: {
      content: {
        width: "200px",
        padding: "12px 15px",
      },
    },
  },
}
